// Shared positioning for the date and time pickers.
//
// Both render their panel as a native popover so it sits in the top layer and cannot be
// clipped by an ancestor's overflow or z-index (the Plantafel drawer, the offcanvas, filter
// modals). The top layer is positioned against the viewport, so the panel has to be placed
// by hand against its anchor.

const GAP = 4

// Places `panel` under `anchor`, flipping above when there is not enough room below, and
// keeping it inside the viewport horizontally.
export function positionPanel(anchor, panel) {
  const box = anchor.getBoundingClientRect()
  const { offsetWidth: width, offsetHeight: height } = panel

  const spaceBelow = window.innerHeight - box.bottom
  const openUpwards = spaceBelow < height + GAP && box.top > height + GAP

  const top = openUpwards ? box.top - height - GAP : box.bottom + GAP
  const left = Math.min(Math.max(GAP, box.left), window.innerWidth - width - GAP)

  panel.style.top = `${Math.max(GAP, top)}px`
  panel.style.left = `${left}px`
}

// Keeps a panel glued to its anchor while the page moves underneath it. Returns a teardown.
export function trackPosition(reposition) {
  window.addEventListener("resize", reposition)
  window.addEventListener("scroll", reposition, true)

  return () => {
    window.removeEventListener("resize", reposition)
    window.removeEventListener("scroll", reposition, true)
  }
}
